import React from "react";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import {Icon} from "@mui/material"; //@material-ui/core   <AutoAwesomeIcon className="icono"/>

function CajaGenerica(props) {

        const isImage = props.icon.endsWith('.png');

        return (
            <div className={"contenedor-caja"}>
                <div className="caja">
                    {isImage ? (
                        <img
                            className={"icono"}
                            style={{background: "none"}}
                            src={process.env.PUBLIC_URL + require(`../imagenes/iconos/${props.icon}`)}
                        alt={"img"}/>

                    ) : (
                        <Icon className="icono">{props.icon}</Icon>
                    )}
                    <h2 className={"titulo"}>{props.titulo}</h2>
                    <p className={"texto"} >{props.texto}</p>
                    <div className="contenedor-enlace">
                        <p className="enlace">Leer más</p>
                        <ArrowForwardIcon
                            fontSize="small"
                            className="enlace-icono"/>
                    </div>
                </div>
            </div>
        );
    }

    export default CajaGenerica;


